import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useRouteMatch } from "react-router-dom";
import { WSQueries } from "../../../../../query/WSQuery";
import { SetupRouteComponentProps } from "../../../../../shared/components/FlowSetup";
import { useBulkCalculate1099BatchSummary } from "../../../../BulkImporter/query/bulkCalculation1099/queries";

import { formatNumber } from "accounting";
import { Layout } from "../../../../../shared/components/Layout";
import { openIntercom } from "../../../../../shared/utils/intercom";
import { useGoToTaxFilingDashboard } from "../../../paths";

export const RouteSubmittingError: React.FC<SetupRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const match = useRouteMatch<{ bulkBatchId: string }>();
  const { bulkBatchId } = match.params;

  const goToDashboard = useGoToTaxFilingDashboard();

  const queryBulkCalculate1099Summary =
    useBulkCalculate1099BatchSummary(bulkBatchId);

  return (
    <Layout title="1099 Filing">
      <WSQueries
        queries={{
          queryBulkCalculate1099Summary
        }}
      >
        {({ queryBulkCalculate1099SummaryData }) => {
          const failed = queryBulkCalculate1099SummaryData.failedTaxForms;

          return (
            <>
              <WSList gap="2XL">
                <WSCard>
                  <WSEmptyState
                    type="error"
                    theme="garnet"
                    orientation="horizontal"
                    title="There was an error submitting the tax forms to the IRS"
                    description={
                      <>
                        There was an error submitting {formatNumber(failed)} tax
                        forms to the IRS. Try again and if the issue persists,
                        please <a onClick={openIntercom}>contact support</a>.
                      </>
                    }
                    actions={{
                      buttons: [
                        {
                          label: "Try again",
                          kind: "Secondary",
                          onClick: onNext
                        }
                      ]
                    }}
                  />
                </WSCard>
                <WSActions
                  alignment="fill"
                  buttons={[
                    {
                      label: "Go to dashboard",
                      onClick: () => {
                        goToDashboard();
                      }
                    }
                  ]}
                />
              </WSList>
            </>
          );
        }}
      </WSQueries>
    </Layout>
  );
};
